import React, { createContext, useContext, useState, ReactNode } from 'react';
import Drawer from '../components/common/Drawer';
import ButtonLegendContent, { LegendItem } from '../components/drawer/ButtonLegendContent';

interface ButtonLegendDrawerContextType {
    showLegend: (items: LegendItem[], title?: string) => void;
}

const ButtonLegendDrawerContext = createContext<ButtonLegendDrawerContextType | undefined>(undefined);

interface ButtonLegendDrawerProviderProps {
    children: ReactNode;
}

export const ButtonLegendDrawerProvider: React.FC<ButtonLegendDrawerProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [items, setItems] = useState<LegendItem[]>([]);
    const [title, setTitle] = useState('Button Guide');

    const showLegend = (legendItems: LegendItem[], legendTitle: string = 'Button Guide') => {
        setItems(legendItems);
        setTitle(legendTitle);
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <ButtonLegendDrawerContext.Provider value={{ showLegend }}>
            {children}
            <Drawer isOpen={isOpen} onClose={handleClose} title={title} size="small">
                <ButtonLegendContent items={items} />
            </Drawer>
        </ButtonLegendDrawerContext.Provider>
    );
};

export const useButtonLegendDrawer = (): ButtonLegendDrawerContextType => {
    const context = useContext(ButtonLegendDrawerContext);
    if (context === undefined) {
        throw new Error('useButtonLegendDrawer must be used within a ButtonLegendDrawerProvider');
    }
    return context;
};
